import Box from '@mui/material/Box/Box'
import CircularProgress from '@mui/material/CircularProgress/CircularProgress'
import CssBaseline from '@mui/material/CssBaseline/CssBaseline'
import ThemeProvider from '@mui/material/styles/ThemeProvider'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import {
	fetchComponentsById,
	fetchRationById,
} from '../../store/rationSystemSlice'
import { COLORS } from '../../styles/colors'
import { fontTheme } from '../../styles/font'
import RationCompositionComp from './RationCompositionComp'
import RationMainInfo from './RationMainInfo'
import RationVersionHistory from './RationVersionHistory'

const theme = fontTheme

const RationViewPage = () => {
	const urlParams = useParams()
	const dispatch = useAppDispatch()

	const { rationInfo, rationCompById, loading, error } = useAppSelector(
		state => state.rationSystemReducer,
	)

	useEffect(() => {
		const fetchData = async () => {
			try {
				await dispatch(fetchComponentsById(urlParams.rationid))
				await dispatch(fetchRationById(urlParams.rationid))
			} catch (error) {}
		}

		fetchData()
	}, [])

	if (loading || !rationInfo || !rationCompById) {
		return (
			<Box
				sx={{
					marginTop: '25%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<CircularProgress
					sx={{
						'&.MuiCircularProgress-colorPrimary': { color: COLORS.main },
					}}
				/>
			</Box>
		)
	} else if (error) {
		;<>{error}</>
	}

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Box
				sx={{ fontFamily: theme.typography.fontFamily, pl: '16px', pr: '40px' }}
			>
				<Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
					<RationMainInfo rationInfo={rationInfo} />
					<RationCompositionComp
						rationInfo={rationInfo}
						rationCompById={rationCompById}
					/>
					<RationVersionHistory
						rationId={rationInfo.id}
						versions={rationInfo.versions}
						activeVersionId={rationInfo.active_version?.id}
					/>
				</Box>
			</Box>
		</ThemeProvider>
	)
}

export default RationViewPage
